<template>
    <div class="same-shipping-address">
        <div class="same-shipping-address__container">
            <input
                class="same-shipping-address__input"
                type="checkbox"
                name="usingned_shipping_address"
                v-model="sameAsShippingAddress"
                :aria-label="$ml.get('sameAddressOption')"
            />

            <div class="same-shipping-address__label-container">
                <i class="same-shipping-address__icon" />

                <label class="same-shipping-address__label" v-text="$ml.get('sameAddressOption')" />
            </div>
        </div>
    </div>
</template>

<script>
import { attr_accessor } from '@/services/VuexAcessor';

export default {
    props: {
        sameAsShipping: {
            type: Boolean,
            default: false
        }
    },

    created() {
        this.sameAsShippingAddress = this.sameAsShipping;
    },

    computed: {
        sameAsShippingAddress: attr_accessor(
            state => state.billingAddress.SameAsShippingAddress,
            'billingAddress/setSameAsShippingAddress'
        ),
    },
};
</script>

<style lang="scss" scoped>
.same-shipping-address {

    &__container {
        display: flex;
        position: relative;
    }

    &__input {
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        cursor: pointer;
        opacity: 0;
        z-index: 3;

        &:checked~.same-shipping-address__label-container .same-shipping-address__icon::after {
            opacity: 1;
        }

        &:checked~.same-shipping-address__label-container .same-shipping-address__icon {
            border-color: #0774E7;
        }

    }

    &__label-container {
        display: flex;
        align-items: center;
    }

    &__icon {
        display: block;
        width: 24px;
        height: 24px;
        border: 1px solid #C5CED7;
        border-radius: 4px;
        margin-right: 16px;
        position: relative;
        transition: all .3s ease;
        flex: 1 0 auto;
        z-index: 2;

        &:after {
            content: url('../../assets/img/checkbox-checked.svg');
            position: absolute;
            top: 50%;
            left: 50%;
            transform: translate(-50%, -50%);
            opacity: 0;
            transition: all .3s ease;
        }
    }

    &__label {
        font-size: 14px;
        font-weight: 500;
        line-height: 18px;
        color: #2F363E;
        margin: 0;
    }
}

</style>

